import { runningInRNWebView, postMessageRN, WebToRNAction } from '@eika-infrastruktur/mobilbank-lib';

export default (textToCopy?: string) => {
    if (!textToCopy) return;
    if (runningInRNWebView) {
        postMessageRN({
            action: WebToRNAction.COPY_TEXT,
            payload: textToCopy,
        });
    } else {
        navigator.clipboard.writeText(textToCopy);
    }
};
